import { getWaermeKwh } from '../../main/functions/getWaermeKwh';
import { IDs } from '../../helpers/IDs';
import { isValid as isValidData } from './validData';

export function isValid(key: string, data: any, entity: string, dataGlobal: any, callback?: (data: any) => void): boolean {
    data = data || {};
    dataGlobal = dataGlobal || {};
    const compare_warning: number = 0.5;
    const dataZaehler: any = {};
    const isConvertable: boolean = entity === IDs.ENT_ENERGIEDATEN_WAERME && ['verbrauch', 'fuellmenge'].indexOf(key) !== -1;
    const jahr: number = +data.jahr || null;
    const standort_tid: number = +data.standort_tid_orig || +data.standort_tid || 0;
    const zaehler_tid: number = +data.zaehler_tid_orig || +data.zaehler_tid || 0;
    const name: string = (((dataGlobal[`${entity}_bundle`] || {}).zaehler_tid || [])
        .find((field: any) => field.tid == zaehler_tid) || {}).zaehlernummer;
    const convertValue = (item: any): number => {
        const value: number = +item[key] || 0;

        if (isConvertable) {
            const einheit: string = (((dataGlobal[`${entity}_bundle`] || {}).einheit_tid || [])
                .find((field: any) => field.tid == (+item.einheit_tid_orig || +item.einheit_tid)) || {}).name;
            const energietraeger: string = (((dataGlobal[`${entity}_bundle`] || {}).energietraeger_tid || [])
                .find((field: any) => field.tid == (+item.energietraeger_tid_orig || +item.energietraeger_tid)) || {}).name;
            return getWaermeKwh(energietraeger, value, einheit, jahr, dataGlobal);
        }
        return value;
    }

    (dataGlobal[entity] || []).forEach((item: any) => {
        if (
            item.standort_tid_orig !== standort_tid || (item.zaehler_tid_orig || 0) !== zaehler_tid || !item.jahr
            || ((item.monat || 0) > 0 || (item.parent_tid || 0) > 1 /*nur Jahreswerte*/) || !isValidData(item, entity, dataGlobal)
        ) {
            return;
        }

        if (typeof dataZaehler[item.jahr] === 'undefined') {
            dataZaehler[item.jahr] = { [key]: 0 };
        }
        dataZaehler[item.jahr][key] += convertValue(item);
    });
    const value: number = +(dataZaehler[jahr] || {})[key] || 0;
    const compare: number[] = [value];
    const values: any[] = [
        { jahr: +jahr - 1, value: +(dataZaehler[+jahr - 1] || {})[key] || 0 },
        { jahr: +jahr + 1, value: +(dataZaehler[+jahr + 1] || {})[key] || 0 }
    ];
    let index: number = null;
    let isGreater: boolean = false;
    let isLess: boolean = false;
    let isValid: boolean = true;
    let percent: number;

    if (value <= 0 || (values[0] <= 0 && values[1] <= 0)) {
        if (typeof callback === 'function') {
            callback({ isGreater, isLess, jahr: null, name });
        }
        return true;
    }

    values.forEach((item: any, i: number) => {
        const curValue: number = item.value || 0;

        switch (true) {
            case (curValue <= 0 || index !== null):
                break;
            case (value < (curValue - (compare_warning * curValue))):
                isLess = true;
                percent = -(1 - (value / curValue)) * 100;
                break;
            case (value > (curValue + (compare_warning * curValue))):
                isGreater = true;
                percent = (value / curValue) * 100;
                break;
            default:
                index = i;
                break;
        }
        index = (index === null && (isLess || isGreater)) ? i : index;

        if (compare.length < 2 && (isLess || isGreater)) {
            compare.push(curValue);
        }
    });

    if (typeof callback === 'function') {
        callback({ compare, isGreater, isLess, isValid, jahr: (isLess || isGreater) ? values[index].jahr : null, name, percent });
    }

    return isValid;
}
